//@flow

import React, { useState } from "react";

import { View } from "@components";

import "./style.scss";

export type TabProps = {
  id?: string,
  title: string,
  icon: string,
  badgeValue: number | string,
  isActive?: boolean,
  className?: string,
  children: React$Node,
  onClick: Function,
  hidden: boolean,
  disabled?: boolean,
};

export function Tab({
  children,
  title,
  icon,
  isActive,
  onClick,
  badgeValue,
  className,
  hidden,
  disabled,
}: TabProps) {
  const active = (isActive && "active") || "";
  return !hidden ? (
    <div
      className={`${className ||
        ""} ${active} tab d-flex align-content-center align-items-center justify-content-center`}
      onClick={onClick}
    >
      {icon && <span className="material-icons">{icon}</span>}
      {title && <div className={`title ${disabled ? "text-color-grey" : ""}`}>{title}</div>}
      {badgeValue !== null && <div className="badge">{badgeValue}</div>}
    </div>
  ) : null;
}
